import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Logo } from '../../assets/icons/logo.svg';
import BackButton from '../../components/BackButton/BackButton';
import Button from '../../components/Button/Button';
import DashBoard from '../../components/DashBoard/DashBoard';
import GuildPhotoBox from '../../components/GuildPhotoBox/GuildPhotoBox';
import AboutHorses from '../../components/HorsesCard/AboutHorses/AboutHorses';
import LabelBox from '../../components/LabelBox/LabelBox';
import Loader from '../../components/Loader/Loader';
import CreateGuildModal from '../../components/Modals/CreateGuildModal/CreateGuildModal';
import DeleteGuildModal from '../../components/Modals/DeleteGuildModal/DeleteGuildModal';
import JoinToGuildModal from '../../components/Modals/JoinToGuildModal/JoinToGuildModal';
import LeaveGuildModal from '../../components/Modals/LeaveGuildModal/LeaveGuildModal';
import MakeOwnerModal from '../../components/Modals/MakeOwnerModal/MakeOwnerModal';
import { pickUserAvatar } from '../../components/PhotoSelect/PhotoSelect';
import { PROFILE_AVATARS } from '../../components/PhotoSelect/PhotoSelectData';
import SubHeader from '../../components/SubHeader/SubHeader';
import Heading from '../../components/Typography/Heading/Heading';
import { Routes } from '../../constants/routes';
import useResponsive from '../../hooks/useResponsive';
import { GuildActionsName, MembersType, PrivacyType } from '../../store/reducers/Guild/guildType';
import AdminGuild from '../AdminGuild/AdminGuild';
import PrivateGuild from '../PrivateGuild/PrivateGuild';
import LeaveGuildButtons from './LeaveGuildButtons/LeaveGuildButtons';
import Members from './Members/Members';
import styles from './MyGuildView.module.scss';
import PrivateButtons from './PrivateButtons/PrivateButtons';
import RaceStatistic from './RaceStatistic/RaceStatistic';
const raceStats = {
    'Total races': '0',
    '1s place': '0',
    '2s place': '0',
    '3s place': '0'
};
const dealsData = [
    {
        name: 'In guild breeding',
        time: '0',
        todayAmount: '-'
    },
    {
        name: 'In guild breeding',
        time: '0',
        todayAmount: '0'
    }
];
const MyGuildView = ({ guildInfoData, memberList, id, myGuildView }) => {
    const params = useParams();
    const { t } = useTranslation();
    const isResponsive = useResponsive('xl');
    const navigate = useNavigate();
    const [makeOwnerModal, setMakeOwnerModal] = useState(false);
    const [joinGuildModal, setJoinGuildModal] = useState(false);
    const [leaveGuildModal, setLeaveGuildModal] = useState(false);
    const [deleteGuildModal, setDeleteGuildModal] = useState(false);
    const [createGuildModal, setCreateGuildModal] = useState(false);
    const pending = useSelector((state) => state.guild.pending);
    const myGuildId = useSelector((state) => state.guild.myGuildId);
    const stats = {
        [t('Class')]: guildInfoData === null || guildInfoData === void 0 ? void 0 : guildInfoData.class,
        [t('Members')]: _jsx(Members, { guildInfoData: guildInfoData })
    };
    const makeMemberImage = (member) => {
        if (member.photo) {
            const path = pickUserAvatar(PROFILE_AVATARS[0].contents, member.photo);
            return _jsx("img", { src: path, alt: "Avatar" });
        }
        else {
            return _jsx(Logo, {});
        }
    };
    const membersList = memberList.map((member) => (Object.assign(Object.assign({}, member), { name: _jsx(LabelBox, { member: member }), photo: makeMemberImage(member.member) })));
    const renderCorrectNameButton = {
        [PrivacyType.PRIVATE]: _jsx(PrivateButtons, { guildInfoData: guildInfoData }),
        [PrivacyType.OPEN]: (_jsx(Button, { color: 2, className: styles.button, height: 'sm', onClick: () => setJoinGuildModal(true), text: t('join') }))
    };
    const renderView = () => {
        if ((guildInfoData === null || guildInfoData === void 0 ? void 0 : guildInfoData.privacy) === PrivacyType.PRIVATE && !guildInfoData.type) {
            return pending.includes(GuildActionsName.GET_MY_GUILD) ? _jsx(Loader, {}) : _jsx(PrivateGuild, {});
        }
        else {
            return pending.includes(GuildActionsName.GET_ALL_GUILDS) ? (_jsx(Loader, {})) : (_jsx(AdminGuild, { id: id, membersList: membersList }));
        }
    };
    const renderButtonsView = () => {
        const isOwner = (guildInfoData === null || guildInfoData === void 0 ? void 0 : guildInfoData.type) === MembersType.OWNER;
        const isAdmin = (guildInfoData === null || guildInfoData === void 0 ? void 0 : guildInfoData.type) === MembersType.ADMIN;
        const isMember = (guildInfoData === null || guildInfoData === void 0 ? void 0 : guildInfoData.type) === MembersType.MEMBER;
        if (isAdmin || isMember)
            return _jsx(LeaveGuildButtons, { setLeaveGuildModal: () => setLeaveGuildModal(true) });
        else if (!(guildInfoData === null || guildInfoData === void 0 ? void 0 : guildInfoData.type) && !myGuildId)
            return renderCorrectNameButton[guildInfoData === null || guildInfoData === void 0 ? void 0 : guildInfoData.privacy];
        else if (isOwner && membersList.length > 1)
            return (_jsx(LeaveGuildButtons, { edit: true, setCreateGuildModal: () => setCreateGuildModal(true), setLeaveGuildModal: () => setMakeOwnerModal(true) }));
        else if (isOwner && membersList.length <= 1)
            return (_jsxs("div", Object.assign({ className: styles.box }, { children: [_jsx(LeaveGuildButtons, { edit: true, setCreateGuildModal: () => setCreateGuildModal(true) }), _jsx(Button, { height: 'sm', onClick: () => setDeleteGuildModal(true), text: t('delete') })] })));
    };
    const handleBack = useCallback(() => {
        navigate('/' + Routes.SOCIAL + '/' + Routes.ALL_GUILD);
    }, []);
    return (_jsxs(_Fragment, { children: [guildInfoData ? (_jsxs("div", Object.assign({ className: styles.element }, { children: [!isResponsive && (_jsx(SubHeader, Object.assign({ className: styles.wrapper, background: true, guildIcon: _jsx(GuildPhotoBox, { guild: guildInfoData }), guildChildren: _jsxs("div", Object.assign({ className: 'd-flex align-items-center' }, { children: [_jsx(AboutHorses, { className: cn(styles.about, 'd-flex align-items-center'), elem: stats }), renderButtonsView()] })), title: guildInfoData === null || guildInfoData === void 0 ? void 0 : guildInfoData.name }, { children: !myGuildView && (_jsx(BackButton, { customCallback: handleBack, className: styles.backButton })) }))), _jsxs(DashBoard, { children: [(guildInfoData === null || guildInfoData === void 0 ? void 0 : guildInfoData.type) === MembersType.OWNER && (_jsx(RaceStatistic, { raceStats: raceStats, dealsData: dealsData })), renderView()] })] }))) : (_jsx("div", Object.assign({ className: styles.noGuildWrapper }, { children: _jsx(Heading, { title: t('you_dont_have_any_guild') }) }))), deleteGuildModal && (_jsx(DeleteGuildModal, { id: id, closeModal: () => setDeleteGuildModal(false) })), leaveGuildModal && (_jsx(LeaveGuildModal, { id: id, closeModal: () => setLeaveGuildModal(false) })), makeOwnerModal && (_jsx(MakeOwnerModal, { id: id, membersList: memberList, closeModal: () => setMakeOwnerModal(false) })), joinGuildModal && (_jsx(JoinToGuildModal, { closeModal: () => setJoinGuildModal(false), id: params.id, title: `${t('are_you_sure_to_want_to_join_to_guild')}?`, buttonName: t('join') })), createGuildModal && (_jsx(CreateGuildModal, { id: id, isEdit: true, text: t('edit_guild'), closeModal: () => setCreateGuildModal(false) }))] }));
};
export default MyGuildView;
